export enum Language {
	ENGLISH = 'en-US',
	TRADITIONAL_CHINESE = 'zh-HK',
	SIMPLIFIED_CHINESE = 'zh-CN',
}
